
import RuntimeApi from "../runtimeEngine/runtimeApi";
import state from "../state";

export function getStringVars() {
	let strvar = "";
    
    let idMap = state.get(["idMap"]);
    
	// Can feed in vars from idMap
	for (let key in idMap) {
	  if (idMap.hasOwnProperty(key)) {
		let newItemObj = state.get(["idMap", key]);
		if (newItemObj !== null) {
		  const newItem = state.get(["activity", "children", newItemObj.listIndex, "children", newItemObj.sectionIndex, "children", newItemObj.itemIndex]);

		  if (key.match(/^[a-zA-Z_$][0-9a-zA-Z_$]*$/) !== null) {
			  strvar = strvar + "var " + key + " = " + "\"" + newItem.value + "\"" + ";"; //eslint-disable-line no-useless-concat   
		  }
		}
	  }
	}
	
	console.log(strvar);

	return strvar;
}

export function evalItemText(item, text) {
    if (text.includes("${")) {
      // Inject global procedure functions
		const af = RuntimeApi;//eslint-disable-line no-unused-vars
		const AmbiFi = RuntimeApi;//eslint-disable-line no-unused-vars
		const item = item;//eslint-disable-line no-unused-vars,no-use-before-define


        const strfun = state.get(["activity", "functions"]);

        const strvar = getStringVars();

        try {
			text = eval(strvar + "\n" + (strfun ? strfun + "\n" : "") + "`" + text + "`");//eslint-disable-line no-eval
        } catch (e) {
            console.log("ERROR: " + e);
            // return "ERROR: " + e;
        }
    }

    return text;
}